import { useState, useEffect } from "react";
import { useAppSelector } from "app/hooks";
import { usePropagateRef } from "lib/hooks/usePropagateRefSingle";
import { useField } from "formik";
import Select from "ui/molecules/Select";

const FieldSelect = ({ dataSource, name, margin, label, subSectionId }: any) => {
  const [field, meta, helpers] = useField(name);
  const error = !!meta.error && meta.touched;
  const [fieldValue, setFieldValue] = useState<string>("");

  const { answers } = useAppSelector((state) => state.survey) ?? [];
  const id = name.split(".")[2];
  const answer =
    answers.find((answer) => answer.questionID === id && answer.subSectionId === subSectionId)?.value ?? "";

  usePropagateRef({
    name,
    setFieldValue,
    value: field?.value,
  });

  useEffect(() => {
    if (meta?.touched) {
      return;
    }
    if (field.value !== fieldValue) {
      setFieldValue(field.value);
    }
  }, [field.value]);

  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(evt?.target?.value);
  };

  const onBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    const val = evt?.target?.value || "";
    window.setTimeout(() => {
      field.onChange({
        target: {
          name: name,
          value: val,
        },
      });
    }, 0);
  };

  const performanceProps = {
    onFocus: onBlur,
  };

  useEffect(() => {
    if (answer) helpers.setValue(answer);
  }, [answer]);
  if (!dataSource) return <></>;
  return (
    <Select
      key={name}
      name={name}
      label={label}
      mapKey='value'
      margin={margin}
      onBlur={onBlur}
      value={fieldValue}
      onChange={onChange}
      id={dataSource?.id}
      mapValue='descripcion'
      dataSource={dataSource ?? []}
      error={error}
      helperText={meta.touched && meta.error}
      {...performanceProps}
    />
  );
};

export default FieldSelect;
